<template>
    <div class="text-center redirect-div">
        REDIRECTING YOU RIGHT ABOUT NOW...
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'redirect',
        created() {
            if(this.$route.params.destination) {
                this.$store.dispatch('redirectToV1', this.$route.params.destination)
            } else {
                this.$router.push('/')
            }
        }
    }
</script>

<style scoped>
    .redirect-div {
        height: 100vh;
        width: 100vw;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>